import Picture from "@components-core/Picture";
import PureComponent from "@components-core/PureComponent";
import RouteLink from "@components-core/RouteLink";
import { connectHOCs } from "@components-utils";
import ProductProps from "@prop-types/ProductProps";
import { ProductCategoryComparatorItemBS } from "@style-variables";
import { getComponentClassName } from "@utils/strings";
import PropTypes from "prop-types";
import React from "react";
import { Card, Nav } from "react-bootstrap";
import ProductPrice from "../Product/Price";
import ProductRating from "../Product/Rating";
import ProductTitle from "../Product/Title";

class ProductCategoryComparatorItem extends PureComponent {
  constructor(props) {
    super(props);

    this.handleItemRemoveClick = this.handleItemRemoveClick.bind(this);
  }

  handleItemRemoveClick(id) {
    this.props.compareItemRemove(id);
  }

  /**
   * @description Helper for getting the subcomponent classname
   * @param {string} suffix The suffix to join (by dash) to the baseclass()
   * @param {string} [otherClassName=null] When given a string to join (by space) to the resulted classname
   * @returns {String} Returns a classname derived from the main component classname
   * @memberof ProductCategoryItem
   */
  getClassName(suffix, otherClassName = null) {
    return getComponentClassName(
      ProductCategoryComparatorItemBS,
      suffix,
      otherClassName
    );
  }

  renderCompareItemRemove() {
    const i18n = this.props.i18n.components.ProductCategorySelector;

    return (
      <div
        className="close position-absolute text-muted mx-2 cursor-pointer"
        aria-label="Close"
        title={i18n.BTN_FILTER_REMOVE}
        style={{ right: 0, zIndex: 1, fontSize: "2rem" }}
        onClick={e => this.props.onClick(this.props.id)}
      >
        <span aria-hidden="true">&times;</span>
      </div>
    );
  }

  renderThumbnail() {
    if (!this.props.img || !this.props.showThumbnail) {
      return null;
    }

    let imgProps = { title: this.props.title };

    if (typeof this.props.img === "string") {
      imgProps.src = this.props.img;
    }
    if (typeof this.props.img === "object") {
      imgProps = { ...imgProps, ...this.props.img };
    }

    return (
      <RouteLink
        to={this.props.buttons.product.href}
        title={this.props.title}
        className="text-center"
      >
        <Nav.Link as="div" className="mx-0 my-3">
          <Picture
            {...imgProps}
            onClick={this.props.buttons.product.onClick}
            className="card-img card-img-top"
            imgSize={{
              ...this.props.imgSize,
              maxHeight: undefined,
              height: this.props.imgSize.maxHeight
            }}
          />
        </Nav.Link>
      </RouteLink>
    );
  }

  renderItemBody() {
    return (
      <Card.Body className={this.getClassName("summary", "pb-0")}>
        <ProductTitle
          title={this.props.title}
          className={this.getClassName("title")}
          onClick={this.props.buttons.product.onClick}
        />
      </Card.Body>
    );
  }

  renderItemPrice() {
    return (
      <ProductPrice
        i18n={this.props.i18n.components.Product}
        newPrice={this.props.newPrice}
        currencyPrefix={this.props.currencyPrefix}
        currencySuffix={this.props.currencySuffix}
        inline
      />
    );
  }

  renderItemRating() {
    return (
      <ProductRating
        rating={this.props.rating}
        className={this.getClassName("rating")}
      />
    );
  }

  render() {
    const compareItemRemove = this.renderCompareItemRemove();
    const compareItemBody = this.renderItemBody();
    const thumbnail = this.renderThumbnail();
    const compareItemPrice = this.renderItemPrice();
    const compareItemRating = this.renderItemRating();

    return (
      <Card
        id={ProductCategoryComparatorItemBS + "-" + this.props.id}
        className={this.getClassName(
          null,
          "text-muted border-light " +
            (this.props.className ? " " + this.props.className : "")
        )}
        style={{ width: this.props.width ? this.props.width : null }}
      >
        {compareItemRemove}
        {thumbnail}
        {compareItemBody}
        {compareItemRating}
        {compareItemPrice}
      </Card>
    );
  }
}

ProductCategoryComparatorItem.propTypes = {
  ...ProductProps(),
  showThumbnail: PropTypes.bool
};

ProductCategoryComparatorItem.defaultProps = {
  showThumbnail: true
};

export default connectHOCs(ProductCategoryComparatorItem, { withSite: true });
